import {
  Component,
  OnInit,
  ViewEncapsulation,
  ElementRef,
  Input,
  AfterViewInit,
} from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { Router, NavigationEnd } from '@angular/router';
import { MenuService } from '../menu.service';
import { AppSettings } from '../../../../app.settings';
import { Settings } from '../../../../app.settings.model';

// dp 09.01.2019 can't find any instance of this component

@UntilDestroy()
@Component({
  selector: 'app-horizontal-menu',
  templateUrl: './horizontal-menu.component.html',
  styleUrls: ['./horizontal-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [MenuService],
  standalone: false,
})
export class HorizontalMenuComponent implements OnInit, AfterViewInit {
  @Input('menuItems') menuItems;
  public settings: Settings;
  constructor(
    public appSettings: AppSettings,
    private menuService: MenuService,
    private router: Router,
    private elementRef: ElementRef
  ) {
    this.settings = this.appSettings.settings;
    this.router.events.pipe(untilDestroyed(this)).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // window.scrollTo(0, 0);
        let activeLink = this.menuService.getActiveLink(this.menuItems);
        this.menuService.setActiveLink(this.menuItems, activeLink);
        // jQuery('.tooltip').tooltip('hide');
      }
    });
  }

  ngOnInit() {
    let menu_wrapper = this.elementRef.nativeElement.children[0];
    this.menuService.createMenu(this.menuItems, menu_wrapper, 'horizontal');

    if (this.settings.theme.menuType === 'mini') {
      // jQuery('.menu-item-link').tooltip();
    }
  }

  ngAfterViewInit() {
    let activeLink = this.menuService.getActiveLink(this.menuItems);
    this.menuService.setActiveLink(this.menuItems, activeLink);
  }
}
